import { useMsal } from "@azure/msal-react";
import { useState } from "react";

import { loginRequest } from "@/lib/auth";

export function LoginPage() {
  const { instance } = useMsal();
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const handleLogin = async () => {
    setBusy(true);
    setError(null);
    try {
      await instance.loginPopup(loginRequest);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-full flex items-center justify-center bg-slate-50">
      <div className="max-w-md w-full bg-white border rounded-xl shadow-sm p-8 text-center space-y-5">
        <div>
          <img src="/logo-mark.png" alt="MPP Energía" className="w-14 h-14 mx-auto mb-3" />
          <div className="text-2xl font-semibold">ETRM</div>
          <div className="text-sm text-slate-500">MPP Energía</div>
        </div>
        <button
          type="button"
          onClick={handleLogin}
          disabled={busy}
          className="w-full inline-flex items-center justify-center gap-2 bg-slate-900 text-white font-medium rounded-md px-4 py-2.5 hover:bg-slate-800 disabled:opacity-50"
        >
          <MicrosoftIcon />
          {busy ? "Conectando…" : "Iniciar sesión con Microsoft"}
        </button>
        <p className="text-xs text-slate-400">
          Solo cuentas @mppenergia.com / @panterainfra.com.
        </p>
        {error && <div className="text-sm text-red-600">{error}</div>}
      </div>
    </div>
  );
}

function MicrosoftIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 23 23" aria-hidden="true">
      <rect x="1" y="1" width="10" height="10" fill="#F35325" />
      <rect x="12" y="1" width="10" height="10" fill="#81BC06" />
      <rect x="1" y="12" width="10" height="10" fill="#05A6F0" />
      <rect x="12" y="12" width="10" height="10" fill="#FFBA08" />
    </svg>
  );
}
